import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { client, urlFor } from '../sanityClient'

function TripDetail() {
  const [trip, setTrip] = useState(null)
  const { slug } = useParams()

  useEffect(() => {
    const query = `*[_type == "trip" && slug.current == $slug][0]{
      title,
      description,
      photo
    }`

    client
      .fetch(query, { slug })
      .then((data) => setTrip(data))
      .catch((error) => {
        console.error('Error fetching trip:', error)
      })
  }, [slug])

  if (!trip) {
    return <div style={styles.loading}>Loading...</div>
  }

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>{trip.title}</h1>
      {trip.photo && (
        <img
          src={urlFor(trip.photo).width(900).url()} // Increased the width of the image
          alt={trip.title}
          style={styles.image}
        />
      )}
      <p style={styles.description}>{trip.description}</p>
    </div>
  )
}

const styles = {
  container: {
    padding: '2rem 1rem',
    backgroundColor: '#F7E7CE',
    textAlign: 'center',
    minHeight: '100vh',
    boxSizing: 'border-box',
    overflowX: 'hidden',           // <-- prevents horizontal overflow
    overflowY: 'auto',             // <-- allows scrolling if needed
    width: '100%',
  },
  loading: {
    textAlign: 'center',
    fontSize: '1.5rem',
    color: '#4A4A4A', // Soft dark gray for the loading message
    padding: '2rem',
  },
  title: {
    fontFamily: 'Georgia, serif',
    fontSize: '2.5rem',
    color: '#4A4A4A', // Soft dark gray for the title
    marginBottom: '1rem',
  },
  image: {
    width: '90%', // Increased to 90% of the container's width
    maxWidth: '900px', // Limit the maximum width for responsiveness
    borderRadius: '12px', // Larger border radius for a softer look
    marginBottom: '1.5rem',
    boxShadow: '0 6px 15px rgba(0, 0, 0, 0.2)', // Enhanced shadow for a polished look
  },
  description: {
    fontSize: '1.2rem',
    lineHeight: '1.8',
    color: '#4A4A4A',
    maxWidth: '800px',
    margin: '0 auto',
    padding: '1rem',
    wordBreak: 'break-word',        // <--- breaks long unspaced words
    overflowWrap: 'break-word',     // <--- ensures long links or tokens break
    whiteSpace: 'pre-wrap',         // <--- preserves line breaks but still wraps
  },
}

export default TripDetail
